<template>
  <div class="row">
    <div class="col-md-12">
      <h6>{{ data.department.name }} Notes</h6>
        <div style="overflow:auto; max-height: 400px;">
          <ckeditor :editor="editor" v-model="data.notes" :config="ckEditorConfig"></ckeditor>
        </div>
      <button type="button" @click="saveNote" class="btn btn-fill btn-info pull-right">
        Update Note
      </button>
    </div>
  </div>
</template>

<script>
import CKEditor from '@ckeditor/ckeditor5-vue'
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor'
import ckEditorConfig from 'src/utilities/ckeditor'

export default {
  props: ['data'],
  components: {
    ckeditor: CKEditor.component
  },
  data() {
    return {
      editor: ClassicEditor,
      ckEditorConfig,
      commitTo: this.data.commitTo,
    }
  },

  methods: {
    saveNote() {
      this.$store.commit(this.commitTo, {
        departmentId: this.data.department.id,
        notes: this.data.notes
      })
      this.$eventHub.$emit('projectNotesUpdated')
      this.$emit('close')
    }
  }
}
</script>
